import React, {PureComponent} from 'react';
import {ResponsiveContainer, ComposedChart, CartesianGrid} from 'recharts';
import theme from '../../constants/theme';
import {parse} from './chart/parse';
import {renderTooltip, renderLegend, renderXAxis, renderYAxis, renderChart} from './chart/render';

class ChartGraph extends PureComponent {
  render() {
    const {data, showLabels} = this.props;
    const parsedData = parse(data);
    return (
      <ResponsiveContainer width={'100%'} height={'100%'}>
        <ComposedChart
          data={parsedData}
          margin={{
            top: theme.spacingHorizontal(2, true),
            right: theme.spacingVertical(2, true),
            left: theme.spacingVertical(2, true),
            bottom: theme.spacingHorizontal(2, true),
          }}>
          <CartesianGrid stroke={theme.lightGray} />
          {renderTooltip()}
          {renderLegend(showLabels)}
          {renderXAxis(data, showLabels)}
          {renderYAxis(data, 'left', 'insideTopLeft', 90)}
          {renderYAxis(data, 'right', 'insideTopRight', -90)}
          {renderChart(data, parsedData, 'left', showLabels)}
          {renderChart(data, parsedData, 'right', showLabels)}
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}

export default ChartGraph;
